import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [ LoadingComponent ],
    declarations: [ LoadingComponent ],
})
export class LoadingModule {}
